export default __webpack_public_path__ + "static/media/expand.b481b2f4.svg";